/* --------------------------------  LOADING  29.11.2017 -------------------------------- */
(function (jQuery) {
  jQuery.gfLoader = function (element, options) {
    const defaults = {
      height: '8px',
      color: '#11D99C',
    };

    this.settings = {};
    const _this = this;

    const _template = '<div class="gf_loader"><div class="gf_loader__progress"></div></div>';

    let _loadingOne;
    let _loadingLoop;
    let _countLoop;

    const $activeElement = jQuery(_template);

    var $element = jQuery(element),
      element = element;

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);
    };

    this.show = function () {
      $element.append($activeElement);
      const $progress = $activeElement.find('.gf_loader__progress');
      $($progress).css({
        height: _this.settings.height,
        background: _this.settings.color,
      });
      _countLoop = 0;
      _loadingOne = setInterval(function () {
        $($progress).css({
          width: _countLoop + '%',
        });
        _countLoop += 4;
        if (_countLoop > 100) {
          clearInterval(_loadingOne);
          _this.Loop();
        }
      }, 10);
    };

    this.Loop = function () {
      const $progress = $activeElement.find('.gf_loader__progress');
      _countLoop = 0;
      _loadingLoop = setInterval(function () {
        $($progress).css({
          width: _countLoop + '%',
        });
        if (_countLoop >= 100) {
          _countLoop = 0;
        }
        _countLoop += 1;
      }, 80);
    };

    this.hide = function (callback) {
      const $progress = $activeElement.find('.gf_loader__progress');
      clearInterval(_loadingOne);
      clearInterval(_loadingLoop);
      $($progress).addClass('gf_loader__end');
      setTimeout(function () {
        if ($element.find('.gf_loader').length > 0) {
          $element.find('.gf_loader').remove();
        }
      }, 200);
      var done = setInterval(function () {
        if (_countLoop >= 100) {
          clearInterval(done);
          $($progress).css({
            height: '0px',
          });
          if (callback) {
            return callback();
          }
        }
        $($progress).css({
          width: _countLoop + '%',
        });
        _countLoop += 1;
      }, 100 / (100 - _countLoop));
    };

    this.init();
  };

  jQuery.fn.gfLoader = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfloader')) {
        const plugin = new jQuery.gfLoader(this, options);
        jQuery(this).data('gfloader', plugin);
      }
    });
  };
})(jQuery);
